import './styles.scss';

const CheckboxGroup = () => import('../../components/checkbox-group/index.vue');

export default {
    name: 'MessagingNotificationTypesPage',

    components: {
        'checkbox-group': CheckboxGroup
    },

    data() {
        return {
            list: [
                {
                    title: 'Text',
                    isChecked: false,
                    id: 'text'
                },
                {
                    title: 'Massey App Notification',
                    isChecked: false,
                    id: 'massey-app-notification'
                },
                {
                    title: 'Email',
                    isChecked: false,
                    id: 'email'
                }
            ]
        }
    },

    computed: {
        subscription() {
            return this.$store.state.subscriptions.active_subscription;
        },

        stored_notification_types() {
            return this.$store.state.messaging.notification_types;
        }
    },

    created() {
        this.$store.commit('setMenuDetails', { 
            title: 'Emergency Messages', 
            slug: 'messaging',
            back_url: '/action/emergency-messages/floors'
        });

        if (this.stored_notification_types.length) {
            this.list = this.stored_notification_types;
        } else {
            this.updateValues(this.list);
        }
    },

    methods: {
        updateValues(list) {
            this.list = list;
            this.$store.commit('setMessageNotificationTypes', list);
        },

        next() {
            this.$store.commit('setMessageNotificationTypes', this.list);
            this.$router.push('/action/emergency-messages/choose-message');
        },

        cancel() {
            this.$ionic.alertController.create({
                header: 'Are you sure you want to cancel?',
                message: 'This action cannot be undone.',
                buttons: [
                    {
                        text: 'Yes',
                        handler: () => {
                            this.$store.commit('resetMessage');
                            this.$router.push('/action');
                        },
                    },
                    {
                        text: 'No',
                        role: 'cancel'
                    }
                ],
            }).then(a => a.present());
        }
    }
};